import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, NgModel } from '@angular/forms';
import { mustBeDifferentThanValidator } from 'app/shared/validators/must-be-different-than';


@Directive({
  selector: '[mustBeDifferentThan]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MustBeDifferentThanValidatorDirective, multi: true }]
})
export class MustBeDifferentThanValidatorDirective implements Validator {
  @Input() mustBeDifferentThan: NgModel;

  validate(control: AbstractControl): { [key: string]: any } {
    return this.mustBeDifferentThan ? mustBeDifferentThanValidator(this.mustBeDifferentThan)(control)
      : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/must-be-different-than.directive.ts